<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="地区" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['area', validatorRules.area]" placeholder="请输入地区"></a-input>
        </a-form-item>
        <a-form-item label="国家" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!-- <a-input v-decorator="['country', validatorRules.country]" placeholder="请输入国家"></a-input> -->
          <m-ore-select
            :showType="true"
            showTypeName="country"
            showTypeValue="country"
            v-decorator="['country', validatorRules.country]"
            url="/infoshop.base/busInfoShopDataRecords/queryDataCountry"
            :asterisk="false"
            :params="{}"
            placeholder="国家"
          >
          </m-ore-select>
        </a-form-item>
        <a-form-item label="城市" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['city', validatorRules.city]" placeholder="请输入城市"></a-input>
        </a-form-item>
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入名称"></a-input>
        </a-form-item>
        <a-form-item label="详细地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['address', validatorRules.address]" placeholder="请输入详细地址"></a-input>
        </a-form-item>
        <a-form-item label="类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            type="list"
            v-decorator="['type', validatorRules.type]"
            :trigger-change="true"
            dictCode="bus_info_shop_type"
            placeholder="请选择类别"
          />
        </a-form-item>
        <a-form-item label="海报图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload
            :uploadData="uploadData2"
            v-decorator="['posterImage', validatorRules.posterImage]"
            :trigger-change="true"
          ></j-upload>
        </a-form-item>
        <a-form-item label="等级" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            type="list"
            v-decorator="['grade', validatorRules.grade]"
            :trigger-change="true"
            dictCode="bus_info_shop_grade"
            placeholder="请选择等级"
          />
        </a-form-item>
        <a-form-item label="旋转角度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!-- <j-dict-select-tag
            type="list"
            v-decorator="['rotate', validatorRules.rotate]"
            :trigger-change="true"
            dictCode="bus_info_shop_grade"
            placeholder="请选择旋转角度"
          /> -->
          <a-input-number v-decorator="['rotate', validatorRules.rotate]" :min="-180" :max="180" />
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-editor v-decorator="['remark', { trigger: 'input' }]" />
        </a-form-item>
        <a-form-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload
            :uploadData="uploadData2"
            v-decorator="['attachment', validatorRules.attachment]"
            :trigger-change="true"
          ></j-upload>
        </a-form-item>
        <a-form-item label="经度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['longitude', validatorRules.longitude]" placeholder="请输入经度"></a-input>
        </a-form-item>
        <a-form-item label="纬度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['latitude', validatorRules.latitude]" placeholder="请输入纬度"></a-input>
        </a-form-item>
        <a-form-item label="是否禁用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch v-decorator="['delFlag', validatorRules.delFlag]" checked-children="是" un-checked-children="否" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JUpload from './JUpload'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import JEditor from '@/components/jeecg/JEditor'
import MOreSelect from './NAmeMOreSelect.vue'
export default {
  name: 'BusInfoShopDataRecordsModal',
  components: {
    JUpload,
    JDictSelectTag,
    JEditor,
    MOreSelect,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        area: { rules: [] },
        country: { rules: [] },
        city: { rules: [] },
        name: { rules: [] },
        address: { rules: [] },
        type: { rules: [] },
        remark: { rules: [] },
        attachment: { rules: [] },
        grade: { rules: [] },
        longitude: { rules: [{ required: true, message: '请输入经度' }] },
        latitude: { rules: [{ required: true, message: '请输入纬度' }] },
      },
      url: {
        add: '/infoshop.base/busInfoShopDataRecords/add',
        edit: '/infoshop.base/busInfoShopDataRecords/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record, { delFlag: record.delFlag == '1' ? true : false })
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'area',
            'country',
            'city',
            'name',
            'address',
            'type',
            'remark',
            'attachment',
            'longitude',
            'latitude',
            'delFlag',
            'posterImage',
            'grade',
            'rotate'
          )
        )
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }
          values.delFlag = values.delFlag ? '1' : '0'
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'area',
          'country',
          'city',
          'name',
          'address',
          'type',
          'remark',
          'attachment',
          'longitude',
          'latitude',
          'grade',
          'rotate'
        )
      )
    },
    uploadData2() {
      return {
        filePath: 'infoshop',
      }
    },
  },
}
</script>
